import css from './Marca.module.css';
/**
 * Símbolo e assinatura da marca, vindos da IDV.
 *
 * SVG inline em vez de <img>: herda a cor do contexto (a lateral escura usa a
 * versão branca) e não gera uma requisição a mais no primeiro carregamento.
 */

interface PropsSimbolo {
  tamanho?: number;
  /** Cor do traço principal. A menta dos detalhes é fixa por identidade. */
  cor?: string;
}

export function Simbolo({ tamanho = 26, cor = 'var(--azul)' }: PropsSimbolo) {
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M10 4h10l7 7v14a3 3 0 0 1-3 3H13a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3z"
        stroke={cor}
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
      <path d="M5.5 11v8.5" stroke={cor} strokeWidth="2.6" strokeLinecap="round" />
      <path
        d="M1.8 16.4 5.5 20.3 9.2 16.4"
        stroke={cor}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 25.6h7"
        stroke="var(--menta)"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <path
        d="M17.6 14.4 14.8 18l2.8 3.6M22.6 14.4 25.4 18l-2.8 3.6"
        stroke="var(--menta)"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface PropsMarca {
  tamanho?: number;
  cor?: string;
  /** Tamanho da fonte do logotipo. */
  fonte?: number;
}

export function Marca({ tamanho = 26, cor = 'var(--azul)', fonte = 21 }: PropsMarca) {
  return (
    <span
      className={css.marca}
      // Cor e tamanho vêm por prop (lateral escura usa branco): variáveis CSS.
      style={{ ['--cor-marca' as string]: cor, ['--tamanho-nome' as string]: `${fonte}px` }}
    >
      <Simbolo tamanho={tamanho} cor={cor} />
      <span className={css.nome}>baixaxml</span>
    </span>
  );
}
